<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">불판 상세</h4>
        </template>
        <div class="row">
          <label class="col-sm-2 col-form-label">불판타입</label>
          <div class="col-sm-10">
            <base-input :disabled="true" v-model="type">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label" v-if="artistName">아티스트명</label>
          <div class="col-sm-10" v-if="artistName">
            <base-input :disabled="true" v-model="artistName">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>

          <label class="col-sm-2 col-form-label" v-if="albumName">앨범명</label>
          <div class="col-sm-10" v-if="albumName">
            <base-input :disabled="true" v-model="albumName">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">시간설정</label>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출시작시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="시작시간">
                  <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출종료시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="종료시간">
                  <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <h4 class="card-title text-left">타겟시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="타겟시간">
                  <el-date-picker type="datetime" placeholder="타겟시간" v-model="targetTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </card>

      <base-button native-type="submit" type="success">수정</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
      <!--      <base-button v-if="threadId" @click="downloadThread" type="default">불판내용저장</base-button>-->
      <base-button v-if="isVisible === 1" @click="setVisible(0)" type="default">숨김</base-button>
      <!--      <base-button v-if="isVisible === 0" @click="setVisible(1)" type="default">표시</base-button>-->
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import { Toast } from "@/util/Toast";

export default {
  components: {
    Card,
    BaseInput,
  },
  async created() {
    if (!this.$route.query.unitId) {
      window.Toast.error("잘못된접근입니다");
      history.go(-1);
      return;
    }
    this.unitId = this.$route.query.unitId;
    if (this.$route.query.threadId) {
      this.threadId = Number(this.$route.query.threadId);
      await this.getData();
    }
  },
  data() {
    return {
      threadId: null,
      title: null,
      artistName: null,
      albumName: null,
      subject: null,
      description: null,
      imageFileId: null,
      imageFileUrl: null,
      link: null,
      startTime: null,
      endTime: null,
      targetTime: null,
      type: null,
      isVisible: null,
      locations: [],
      threadLocations: [
        {
          label: "스케줄",
          value: "schedule",
        },
      ],
    };
  },
  methods: {
    addThreadLocation() {
      this.locations.push({});
    },
    removeThreadLocation(index) {
      this.locations.splice(index, 1);
    },
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },

    async getData() {
      return this.$axios.get(`/thread/${this.threadId}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.startTime = data.startTime;
          this.endTime = data.endTime;
          this.targetTime = data.targetTime;
          this.type = data.type;
          this.artistName = data.artistName || null;
          this.albumName = data.albumName || null;

          this.isVisible = data.isVisible;
        }
      });
    },
    async setVisible(isVisible) {
      return this.$axios
        .put(`/thread/${this.threadId}/visible`, {
          params: { isVisible },
        })
        .then((res) => {
          Toast.success("상태가 변경되었습니다");
          this.isVisible = isVisible;
        });
    },
    async onSubmit() {
      if (this.threadId) {
        const updateParam = {
          startTime: this.startTime,
          endTime: this.endTime,
          targetTime: this.targetTime,
        };
        return this.$axios
          .put(`/thread/${this.threadId}`, { params: updateParam })
          .then(() => {
            Toast.success("불판이 수정되었습니다");
            history.go(-1);
          })
          .catch((error) => {
            Toast.error(error.response.data.error.message);
          });
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.has-image {
  padding-top: 100px;
}
.artist-selection {
  margin-bottom: 20px;
}
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>
